<template>
    <div class="form-group">
        <label :for="fieldId">{{ name }}</label>
        <select :id="fieldId" :name="name" class="form-control">
            <option v-for="optionId in options" :value="field.labels[optionId]">{{ field.labels[optionId] }}</option>
        </select>
    </div>
</template>

<script>
    export default {
        name: 'Radio',
        props: [
            'fieldId',
        ],
        components: {},
        computed: {
            name() {
                return this.field.labels[this.field.labelsOrder[0]]
            },
            field() {
                const { state } = this.$store

                return state.fields[this.fieldId]
            },
            options() {
                return this.field.labelsOrder.slice(1)
            },
        },
        methods: {},
    }
</script>

<style lang="scss" scoped>
    .fb-box {
        margin-left: 0 !important;
    }
</style>
